/**
 * @generated SignedSource<<b466e5a5db03aca0b437cf003393dbba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell";
};
export type OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell$key = {
  readonly " $data"?: OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "OriginalEstimateCell_OriginalEstimateTimeTrackingFieldCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "originalEstimate_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraTimeTrackingField"
};

(node as any).hash = "2c3d3c8f77186bb4daccfec9a1c84692";

export default node;
